import { ConsultarProcesso } from 'store/modules/api/iirgd/integrador/consultarProcesso/types';
import {
	CINValidationMessages,
	CINDescriptionCodeSituation,
} from '../messages/cin';

export const getDescricaoSituationCin = (codSitCad: string) => {
	switch (codSitCad) {
		case '2':
			return 'Suspensa';
		case '3':
			return 'Titular Falecido';
		case '5':
			return 'Cancelada por Multiplicidade';
		case '8':
			return 'Nula';
		case '9':
			return 'Cancelada de Ofício';
		default:
			return 'Descrição desconhecida';
	}
};

const IsCinSp = (proccess: ConsultarProcesso) => {
	if (proccess.ufEmissao && proccess.ufEmissao === 'SP') {
		return { isUFSP: true, descUF: 'SP' };
	}
	if (proccess.ufEmissao && proccess.ufEmissao !== 'SP') {
		return { isUFSP: false, descUF: `${proccess.ufEmissao}` };
	}
	return { isUFSP: false, descUF: 'UF desconhecida' };
};

const getMostRecentProccessCin = (processos: ConsultarProcesso[]) => {
	if (processos.length === 0) {
		const withoutCINProccess = null;
		return withoutCINProccess;
	}

	const mostRecentProcesso = processos.reduce((latest, current) => {
		const latestDate = new Date(latest.dataHoraProtocoloRFB);
		const currentDate = new Date(current.dataHoraProtocoloRFB);

		return currentDate.getTime() > latestDate.getTime() ? current : latest;
	});

	return mostRecentProcesso;
};

export const verifyCinProccesses = (processos: ConsultarProcesso[]) => {
	const proccess = getMostRecentProccessCin(processos);

	if (!proccess) {
		return { isAllowed: true };
	}

	const { codigoSituacao } = proccess;
	const cinSP = IsCinSp(proccess);
	const isSP = cinSP.isUFSP;

	// const UF_DIF_SP_MESSAGE = `Emissão de CIN não poderá ser realizada neste momento no estado de São Paulo. CPF com CIN emitida em outro estado da federação - ${cinSP.descUF}`;

	const situationMessages = {
		1: CINDescriptionCodeSituation.codSituation1,
		2: CINDescriptionCodeSituation.codSituation2,
		3: CINDescriptionCodeSituation.codSituation3,
		4: CINDescriptionCodeSituation.codSituation4,
	} as const;

	// ---------------------------
	// SITUAÇÃO 1 E 2 => sempre bloquear
	// ---------------------------
	if (codigoSituacao === 1 || codigoSituacao === 2) {
		const message = isSP
			? `${CINValidationMessages.ufAttendancySP}: ${situationMessages[codigoSituacao]}`
			: `${CINValidationMessages.ufDifferentSP} - ${cinSP.descUF}`;

		return {
			isAllowed: false,
			message,
		};
	}

	// ---------------------------
	// SITUAÇÃO 3
	//  SP => permitir
	//  Diferente SP => bloquear
	// ---------------------------
	if (codigoSituacao === 3) {
		if (isSP) {
			return { isAllowed: true };
		}

		return {
			isAllowed: false,
			message: `${CINValidationMessages.ufDifferentSP} - ${cinSP.descUF}`,
		};
	}

	// ---------------------------
	// SITUAÇÃO 4 => sempre permitir
	// ---------------------------
	if (codigoSituacao === 4) {
		return { isAllowed: true };
	}

	// fallback
	return { isAllowed: false };
};
